import URLQuery,{ getUrlParams } from 'query-string-manipulator';
import IDMUtils from './../IDMUtils';

/**
 *
 */
export default class APIRequest {

  /**
   * constructor - description
   *
   * @param  {type} method description
   * @return {type}        description
   */
  constructor(method) {
    this.baseURL = null;
    this.path = null;
    this.method = method;
    this.headers = {};
    this.body = {};
    this.bodyType = 'JSON';
    this.queryParameters = {};
  }

  /**
   * async exec - description
   *
   * @return {type}  description
   */
  async exec() {
    try {
      //Build URL
      const reqURL = URLQuery(this.baseURL + (this.path || ''), { set: this.queryParameters });
      //
      let fetcher = null;
      if (!IDMUtils.isNodeJS()) {
        await import('whatwg-fetch'); //IE polyfill for fetch
        fetcher = fetch;
      } else fetcher = require('node-fetch');
      //Make request
      const respObj = await fetcher(reqURL, this._buildRequest());
      return await this._buildResponse(respObj);
    } catch (e) {
      console.error(e);
      return {error: e, statusCode: -1};
    }
  }

  /**
   * appendHeader - description
   *
   * @param  {type} key   description
   * @param  {type} value description
   * @return {type}       description
   */
  appendHeader(key, value) { this.headers[key] = value; }

  /**
   * appendQueryParam - description
   *
   * @param  {type} key   description
   * @param  {type} value description
   * @return {type}       description
   */
  appendQueryParam(key, value) { this.queryParameters[key] = value; }
  _buildRequest() {
    let request = {
      method: this.method, redirect: 'follow',
      ...(Object.keys(this.headers).length > 0 ? { headers: this.headers } : {}),
    };
    if (this.bodyType == 'JSON') {
      if (Object.keys(this.body).length > 0) request.body = JSON.stringify(this.body);
    } else if (this.bodyType == 'BINARY') {
      if (this.body && this.body.length > 0) request.body = this.body;
    } else { if (this.body) request.body = this.body; }
    return request;
  }
  async _buildResponse(respObj) {
    const contentType = respObj.headers.get('Content-Type');
    if (contentType && contentType.includes('json')) {
      //handle 204 bodies.. should have a better way
      let body = null;
      try { body = await respObj.json(); }
      catch(e) { console.error(e) }
      //
      return { body, statusCode: respObj.status };
    } else if ((contentType && contentType.includes('image')) || this.bodyType == 'BINARY') {
      return { body: await respObj.blob(), statusCode: respObj.status };
    } return { body: await respObj.text(), statusCode: respObj.status };
  }
}
